import { asyncMiddleware } from '@/router';
import { PasswordRecoveryService } from '@/services/passwordRecovery';
import { APPLICATION_ROUTES } from '@/router/routes_type';

export const passwordRecoveryProcess: asyncMiddleware = async () => {
  if (!PasswordRecoveryService.verification) {
    return { name: APPLICATION_ROUTES.PASSWORD_FORGOT };
  }
};
